import { Control } from "rete";
import SelectComponent from "./select-component";

export class SelectControl extends Control {
  constructor(emitter, key, type, readonly, placeholder, comp) {
    super(key);
    this.component = SelectComponent;
    this.props = {
      emitter,
      ikey: key,
      type,
      readonly,
      placeholder,
      comp
    };
  }

  setValue(value) {
    this.vueContext.value = value;
  }
}
